import fetch from '../fetch';

import {
  INTEGRAL_POOL_LIST,
  INTEGRAL_POOL_DETAIL,
  ADD_INTEGRAL_ACCOUNT,
  ADD_INTEGRAL,
  DELAY_INTEGRAL,
  INTEGRAL_WARNING_LIST,
  INTEGRAL_WARNING_DETAIL,
  ADD_INTEGRAL_WARNING,
  ADD_WARNING_EMAIL,
  DELETE_WARNING_EMAIL,
  INTEGRAL_VERIFY_LIST,
  INTEGRAL_VERIFY_PASS,
  GET_POINT_ACCOUNT_RECORD,
  ADD_INTEGRAL_VERIFY,
  INTEGRAL_VERIFY_DETAIL,
  INTEGRAL_BASIC_DATA,
  ABOLISH_INTEGRAL_POOL,
  REDUCE_INTEGRAL,
  INTEGRAL_PURCHASE_LIST,
  ADD_PURCHASE_ACCOUNT,
} from '../url';

// 查询积分池列表
function getIntegralPoolList(data) {
  return fetch({
    url: INTEGRAL_POOL_LIST,
    method: 'post',
    data: data
  });
}

// 查询单条积分池列表数据
function getIntegralPoolDetail(data) {
  return fetch({
    url: INTEGRAL_POOL_DETAIL,
    method: 'post',
    data: data
  });
}

// 新增积分池账户
function addIntegralPoolAccount(data) {
  return fetch({
    url: ADD_INTEGRAL_ACCOUNT,
    method: 'post',
    data: data
  });
}

// 新增积分池账户
function addPurchaseAccount(data) {
  return fetch({
    url: ADD_PURCHASE_ACCOUNT,
    method: 'post',
    data: data
  });
}

// 增加积分
function addIntegral(data) {
  return fetch({
    url: ADD_INTEGRAL,
    method: 'post',
    data: data
  });
}

// 延期积分
function delayIntegral(data) {
  return fetch({
    url: DELAY_INTEGRAL,
    method: 'post',
    data: data
  });
}

// 查询积分池预警列表
function getIntegralPoolWarningList(data) {
  return fetch({
    url: INTEGRAL_WARNING_LIST,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

// 查询单条预警积分
function getIntegralPoolWarningDetail(data) {
  return fetch({
    url: INTEGRAL_WARNING_DETAIL,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

// 设置预警积分
function setIntegralWarning(data) {
  return fetch({
    url: ADD_INTEGRAL_WARNING,
    method: 'post',
    data: data
  });
}

// 设置预警邮箱
function setIntegralWarningEmail(data) {
  return fetch({
    url: ADD_WARNING_EMAIL,
    method: 'post',
    data: data
  });
}

// 删除预警邮箱
function deleteIntegralWarningEmail(data) {
  return fetch({
    url: DELETE_WARNING_EMAIL,
    method: 'post',
    data: data
  });
}

// 查询积分池审核列表
function getIntegralVerifyList(data) {
  return fetch({
    url: INTEGRAL_VERIFY_LIST,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

// 查询审核通过列表
function getIntegralVerifyPassList(data) {
  return fetch({
    url: INTEGRAL_VERIFY_PASS,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

// 查询积分池流水列表
function getPointAccountRecord(data) {
  return fetch({
    url: GET_POINT_ACCOUNT_RECORD,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

// 设置积分池审核
function setIntegralVerify(data) {
  return fetch({
    url: ADD_INTEGRAL_VERIFY,
    method: 'post',
    data: data
  });
}

// 查询单条审核记录
function getIntegralVerifyDetail(data) {
  return fetch({
    url: INTEGRAL_VERIFY_DETAIL,
    method: 'post',
    data: data
  });
}

// 查询审核基础数据
function getIntegralBasicData(data) {
  return fetch({
    url: INTEGRAL_BASIC_DATA,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

/**
 * 积分池作废
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function abolishIntegralPool(data) {
  return fetch({
    url: ABOLISH_INTEGRAL_POOL,
    method: 'post',
    data: data
  });
};

/**
 * 积分扣减
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function reduceIntegral(data) {
  return fetch({
    url: REDUCE_INTEGRAL,
    method: 'post',
    data: data
  });
};

/**
 * 积分采购管理列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function integralPurchaseList(data) {
  return fetch({
    url: INTEGRAL_PURCHASE_LIST,
    method: 'post',
    data: data
  });
};

const integralPool = {
  getIntegralPoolList,
  getIntegralPoolDetail,
  addIntegralPoolAccount,
  addIntegral,
  delayIntegral,
  getIntegralPoolWarningList,
  getIntegralPoolWarningDetail,
  setIntegralWarning,
  setIntegralWarningEmail,
  deleteIntegralWarningEmail,
  getIntegralVerifyList,
  getIntegralVerifyPassList,
  getPointAccountRecord,
  setIntegralVerify,
  getIntegralVerifyDetail,
  getIntegralBasicData,
  abolishIntegralPool,
  reduceIntegral,
  integralPurchaseList,
  addPurchaseAccount,
};

export { integralPool };
